import flagSvg from './he-flag.svg';

export default function HeFlag() {
  return <img src={flagSvg} alt="Hebrew" />;
}
